/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { minSearchLength } from "~/components/SearchInput/const";
import { isNotEmpty } from "~/tools";

// phrase is updated only when requirements are met, thus preventing api hooks from being called
export function useGetSearchPhrase(input: string | undefined) {
  const trimmed = input?.trim() || "";
  const isSearchAllowed = !trimmed || trimmed.length >= minSearchLength;
  const phrase = isSearchAllowed && isNotEmpty(trimmed) ? trimmed : undefined;
  return { phrase, isSearchAllowed };
}
